/**
 * Device type enumeration
 */
export enum DeviceType {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  UNKNOWN = 'unknown',
}

/**
 * Get device type
 * @returns Device type
 */
export const getDeviceType = (): DeviceType => {
  const userAgent = navigator.userAgent.toLowerCase();
  const screenWidth = window.screen.width;

  // Check for mobile devices
  const isMobile =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
      userAgent
    );

  // Check for tablet devices
  const isTablet =
    /ipad|android(?!.*mobile)/i.test(userAgent) ||
    // iPadOS Safari는 데스크톱 UA를 사용하므로 터치 + 멀티터치로 감지
    (navigator.maxTouchPoints > 1 && /Macintosh/i.test(userAgent)) ||
    (screenWidth >= 768 && screenWidth < 1024);

  if (isMobile && !isTablet) {
    return DeviceType.MOBILE;
  } else if (isTablet) {
    return DeviceType.TABLET;
  } else if (screenWidth >= 1024) {
    return DeviceType.DESKTOP;
  } else {
    return DeviceType.UNKNOWN;
  }
};

/**
 * Check if device is mobile
 * @returns Whether device is mobile
 */
export const isMobile = (): boolean => {
  return getDeviceType() === DeviceType.MOBILE;
};

/**
 * Check if device is tablet
 * @returns Whether device is tablet
 */
export const isTablet = (): boolean => {
  return getDeviceType() === DeviceType.TABLET;
};

/**
 * Check if device is desktop
 * @returns Whether device is desktop
 */
export const isDesktop = (): boolean => {
  return getDeviceType() === DeviceType.DESKTOP;
};

/**
 * Check if device is mobile or tablet
 * @returns Whether device is mobile or tablet
 */
export const isMobileOrTablet = (): boolean => {
  return (
    getDeviceType() === DeviceType.MOBILE ||
    getDeviceType() === DeviceType.TABLET
  );
};

/**
 * Get screen size category
 * @returns Screen size category
 */
export const getScreenSize = ():
  | 'small'
  | 'medium'
  | 'large'
  | 'extra-large' => {
  const screenWidth = window.screen.width;

  if (screenWidth < 768) {
    return 'small';
  } else if (screenWidth < 1024) {
    return 'medium';
  } else if (screenWidth < 1440) {
    return 'large';
  } else {
    return 'extra-large';
  }
};
